export const END_ROUTE_LOADING = 'END_ROUTE_LOADING';
export const SIDE_NAV_SNAP_THRESHOLD = 20;
